import { useState } from 'react';
import wallpaper from './wallpaper.png';
import { Link } from 'react-router-dom';
import './Burger.css';

const links = [
  { id: 'home', label: 'Home', link: '/' },
  { id: 'books', label: 'Books', link: '/books' },
  { id: 'blog', label: 'Blog', link: '/blog' },
  { id: 'characters', label: 'Characters', link: '/characters' },
  { id: 'about', label: 'About', link: '/' },
];

function Burger() {
  const [open, setOpen] = useState(false);

  const handleNavigate = (id) => {
    setTimeout(() => {
      setOpen(false);
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 100)
  };

  return (
    <>
      <button
        type="button"
        className={`nav-toggle${open ? ' nav-toggle-open' : ''}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
      >
        <svg width="35px" height="35px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className="burger-icon">
          <path fill="white" d="M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z"></path>
        </svg>
      </button>

      <div className={`nav-menu${open ? ' nav-menu-open' : ''}`} style={{ backgroundImage: `url("${wallpaper}")` }}>
        <nav className="nav-menu-links">
          {links.map((link) => (
            <Link to={link.link} key={link.id}>
              <button
                type="button"
                key={link.id}
                className="nav-menu-link"
                onClick={() => handleNavigate(link.id)}
              >
                {link.label}
              </button>
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
}

export default Burger;
